import React, {useState} from "react";

import Page from "@/components/Page";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import VLFModal from "@/components/Modal";
import Tabs from "@/components/Tabs";
import ChoiceChips from "@/components/ChoiceChips";
import StatusBadge from "@/components/StatusBadge";
import Kpi, {KpiRow} from "@/components/Kpi";
import DataTable from "@/components/DataTable";
import EmptyData from "@/components/EmptyData";
import PlayerAvatar from "@/components/PlayerAvatar";
import PlayerHero from "@/components/PlayerHero";
import ScoreRing from "@/components/ScoreRing";
import VLFTextField from "@/components/Input/TextField";
import VLFSelectNew from "@/components/Input/SelectNew";
import VLFDatePicker from "@/components/Input/DatePicker";

import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";

import {COLORS} from "@/style/utils";

import "./index.scss";

const FONT_SIZES = [
	"caption",
	"small",
	"body",
	"title",
	"display",
	"headline",
	"data",
];

const ROWS = [
	{
		id: 1,
		name: "Leone Filippo",
		role: "Portiere",
		minutes: 810,
		status: "good",
	},
	{
		id: 2,
		name: "Costa Marco",
		role: "Difensore",
		minutes: 450,
		status: "warning",
	},
	{
		id: 3,
		name: "Bianco Elia",
		role: "Centrocampista",
		minutes: 0,
		status: "critical",
	},
];

const STATUS_LABELS = {
	good: "Disponibile",
	warning: "Da valutare",
	critical: "Infortunato",
};

// Catalogo dei componenti base: serve a controllare che restino uguali ovunque
function SettingsComponentsPage() {
	const [chip, setChip] = useState("all");
	const [tab, setTab] = useState("one");
	const [text, setText] = useState("");
	const [select, setSelect] = useState(null);
	const [date, setDate] = useState(null);
	const [openModal, setOpenModal] = useState(false);

	const section = (title, content) => (
		<div className="components-page__section">
			<VLFCard title={title} content={content} />
		</div>
	);

	return (
		<Page>
			<Breadcrumbs current="Componenti" />
			<div className="components-page">
				{section(
					"Colori",
					<div className="components-page__swatches">
						{Object.entries(COLORS).map(([name, value]) => (
							<div key={name} className="components-page__swatch">
								<span
									className="components-page__swatch-color"
									style={{background: value}}
								/>
								<span>{name}</span>
								<span className="components-page__muted">{value}</span>
							</div>
						))}
					</div>,
				)}
				{section(
					"Caratteri",
					<div className="components-page__fonts">
						<div className="components-page__family components-page__family--display">
							Titoli · Poppins
						</div>
						<div className="components-page__family components-page__family--numeric">
							Numeri · 842′ · 2–1 · € 12.000
						</div>
						<div className="components-page__family">Testo · Inter</div>
						{FONT_SIZES.map((size) => (
							<div key={size} className={"components-page__font--" + size}>
								{size} · Casa – Ospiti 2–1
							</div>
						))}
					</div>,
				)}
				{section(
					"Pulsanti",
					<MainActions
						actions={[
							{icon: <AddIcon />, label: "Nuova gara", onClick: () => {}},
							{
								icon: <RefreshIcon />,
								label: "Aggiorna",
								variant: "outlined",
								onClick: () => {},
							},
							{label: "Apri finestra", onClick: () => setOpenModal(true)},
						]}
					/>,
				)}
				{section(
					"Campi",
					<div className="components-page__fields">
						<div>
							<VLFTextField
								label="Nome"
								name="name"
								value={text}
								onChange={(e) => setText(e.target.value)}
							/>
						</div>
						<div>
							<VLFSelectNew
								label="Ruolo"
								options={ROWS.map((r) => ({value: r.role, label: r.role}))}
								sorted={false}
								value={select}
								onChange={setSelect}
							/>
						</div>
						<div>
							<VLFDatePicker label="Data" value={date} onChange={setDate} />
						</div>
					</div>,
				)}
				{section(
					"Scelta a pulsanti",
					<ChoiceChips
						options={[
							{value: "all", label: "Tutti", count: 24},
							{value: "available", label: "Disponibili", count: 21},
							{value: "injured", label: "Infortunati", count: 3},
						]}
						value={chip}
						onChange={setChip}
					/>,
				)}
				{section(
					"Schede",
					<Tabs
						freeHeight
						tabs={[
							{
								key: "one",
								label: "Prima",
								render: () => "Contenuto della scheda",
							},
							{key: "two", label: "Partita", render: () => "Cronaca"},
							{key: "three", label: "Dopo", render: () => "Analisi"},
						]}
						currentTab={tab}
						setCurrentTab={setTab}
					/>,
				)}
				{section(
					"Stato",
					<div className="components-page__row">
						<StatusBadge tone="good" label="Disponibile" />
						<StatusBadge tone="warning" label="Da valutare" />
						<StatusBadge tone="critical" label="Infortunato" />
						<StatusBadge tone="neutral" label="Non convocato" />
					</div>,
				)}
				{section(
					"Numeri in evidenza",
					<KpiRow>
						<Kpi label="Giocatori" value={24} note="in rosa" />
						<Kpi label="Disponibili" value="21" tone="good" />
						<Kpi label="In dubbio" value="2" tone="warning" />
						<Kpi label="Infortunati" value="1" tone="critical" />
					</KpiRow>,
				)}
				{section(
					"Voto ad anello",
					<div className="components-page__row">
						<ScoreRing value={7.4} label="Buono" />
						<ScoreRing value={6.3} label="Sufficiente" />
						<ScoreRing value={5.5} label="Basso" />
						<ScoreRing value={null} label="Nessun voto" />
						<ScoreRing value={3.5} max={5} size="small" label="Su 5" />
						<ScoreRing value={7.1} size="large" label="Scheda" />
					</div>,
				)}
				{section(
					"Giocatore",
					<div className="components-page__stack">
						<div className="components-page__row">
							<PlayerAvatar firstName="Luca" lastName="Ferri" size="small" />
							<PlayerAvatar firstName="Luca" lastName="Ferri" />
							<PlayerAvatar
								firstName="Luca"
								lastName="Ferri"
								size="large"
								status="critical"
								statusLabel="Infortunato"
							/>
						</div>
						<PlayerHero
							player={{firstName: "Luca", lastName: "Ferri"}}
							chips={[
								{id: "role", label: "Centrocampista", tone: "primary"},
								{id: "age", label: "17 anni"},
								{id: "nationality", label: "Italia"},
								{id: "contract", label: "Contratto 06/2027", tone: "good"},
							]}
							scores={[
								{id: "rating", label: "Valutazione", value: 7.2},
								{id: "match", label: "Voto gara", value: 6.4},
							]}
						/>
					</div>,
				)}
				{section(
					"Tabella",
					<DataTable
						columns={[
							{key: "name", label: "Giocatore", sortable: true},
							{key: "role", label: "Ruolo", sortable: true},
							{key: "minutes", label: "Minuti", align: "right", sortable: true},
							{
								key: "status",
								label: "Stato",
								render: (row) => (
									<StatusBadge
										tone={row.status}
										label={STATUS_LABELS[row.status]}
									/>
								),
							},
						]}
						rows={ROWS}
						onRowClick={() => {}}
					/>,
				)}
				{section(
					"Vuoto",
					<EmptyData
						action={
							<MainActions
								actions={[
									{
										icon: <AddIcon />,
										label: "Nuovo allenamento",
										onClick: () => {},
									},
								]}
							/>
						}
					>
						Nessun allenamento in questa settimana.
					</EmptyData>,
				)}
			</div>
			<VLFModal
				open={openModal}
				title="Finestra"
				content={<div>Le finestre usano sempre questo componente.</div>}
				close={() => setOpenModal(false)}
				confirm={() => setOpenModal(false)}
			/>
		</Page>
	);
}

export default SettingsComponentsPage;
